import { JobSimilarPositionsProps } from '@restworld/utils-common';

import { Wrapper } from '@restworld/ui-components';
import { JobPositionCardCarousel } from '../job-position-card-carousel';
import { Heading } from '@restworld/ui-ds-base';
import { BriefcaseIcon } from '@heroicons/react/24/outline';
import { useTranslation } from 'next-i18next';

export const JobSimilarPositions = (props: JobSimilarPositionsProps) => {
  const { t } = useTranslation('job-position-page');
  return (
    <Wrapper id="similar-jobs-el">
      <span className="flex items-center gap-1">
        <BriefcaseIcon className="h-6 w-6" />
        <Heading size={4} weight="semibold">
          {t('similar_positions')}
        </Heading>
      </span>
      <JobPositionCardCarousel {...props} />
    </Wrapper>
  );
};
export default JobSimilarPositions;
